// extracted by mini-css-extract-plugin
module.exports = {"warningIconWrapper":"CascadeCard_warningIconWrapper__21gNr","warningIcon":"CascadeCard_warningIcon__1oxfZ"};